<script lang="ts">
    import type {SearchManager} from '../../search-manager';
    import type {LocalizeFunction} from '../../../svelte/types';
    import {getContext, onDestroy} from 'svelte';
    import {LOCALIZE_KEY, pipe} from '../../../svelte/utils';
    import {loc} from '../../../svelte/pipes';
    import type {Sorting} from '../../../typings/portaro.be.types';
    import {getFirstById} from '../../../shared/utils/array-utils.fp';

    export let searchManager: SearchManager;

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);

    let selectedSorting: Sorting;
    let lastSearch = searchManager.lastSearch();
    const searchResultNotificationSubscription = searchManager.getNewSearchResultNotification$().subscribe(() => {
        lastSearch = searchManager.lastSearch();
        if (!!searchManager.params()?.sorting) {
            selectedSorting = getFirstById<Sorting, string>(searchManager.params().sorting.id)(lastSearch.availableSortings);
        }
    });

    function onChange() {
        searchManager.params().sorting = selectedSorting;
        searchManager.newSearch();
    }

    onDestroy(() => {
        searchResultNotificationSubscription.unsubscribe();
    })

</script>

<template>
    {#if !!lastSearch && lastSearch.features && searchManager.lastSearch().features.includes('sorting') && lastSearch.availableSortings.length > 1}
        <label for="search-sorting-select">{localize(/* @kp-localization hledani.razeni.SeraditVysledkyPodle */ 'hledani.razeni.SeraditVysledkyPodle')}:</label>
        <select id="search-sorting-select" bind:value={selectedSorting} on:change={onChange}>
            {#each lastSearch.availableSortings as sorting (sorting.id)}
                <option value={sorting}>
                    {pipe(sorting, loc())}
                </option>
            {/each}
        </select>
    {/if}
</template>